import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import CustomAccordion from "../../utils/Accordion/CustomAccordion";
import "../../Assets/Styles/Style.css";
import useApi from "../../utils/useApi";
import { Modal, Box, Typography, Button, TextField } from "@mui/material";
import { Delete } from "@mui/icons-material";

function Transaction({ data, height }) {
  const { Get, Post, Patch, getAPI, Delete } = useApi();
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [newInvestmentId, setNewInvestmentId] = useState();
  const [curTrxnId, setCurTrxnId] = useState();
  const [subscriptionAmt, setSubscriptionAmt] = useState(0);
  const [toGroup, setToGroup] = useState();
  const [toSubscription, setToSubscription] = useState();
  const [toUsername, setToUsername] = useState();
  const [toPhone, setToPhone] = useState();

  let openModel = (investmentId, trxnId) => {
    setCurTrxnId(trxnId);
    setNewInvestmentId(null);
    setIsOpen(true);
    setOpen(true);
  };

  let checkToInvestment = async () => {
    await Get(
      `${getAPI(
        "getTransactionsByInvestmentNo"
      )}${toGroup.toUpperCase()}-${toSubscription}/`
    ).then((resp) => {
      setNewInvestmentId(resp.investment_info.id);
      setToUsername(resp.user_info.full_name);
      setToPhone(resp.user_info.phone_no);
    });
  };
  let transferTrxn = async () => {
    await Patch("transaction", curTrxnId, {
      investment: newInvestmentId,
    }).then((resp) => {
      alert("Transaction updated");
    });
  };

  let deleteTrxn = async () => {
    await Delete("transaction", curTrxnId).then((resp) => {
      alert("Transaction Deleted");
    });
  };
  let hideTrxn = async () => {
    await Patch("transaction", curTrxnId, {
      is_deleted: true,
    }).then((resp) => {
      alert("Transaction hide for customer!");
    });
  };
  useEffect(() => {
    setSubscriptionAmt(data.subscription_info?.subscription_amt || data.group_info.subscription_amt);
  }, [data]);

  const accordionSections = [
    {
      label: "Transactions",
      content: (
        <div className="transaction-container">
          <Modal open={open} onClose={() => setOpen(false)}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "40%",
                bgcolor: "white",
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
              }}
            >
              {toPhone ? (
                <p>
                  Transfer Transaction to{" "}
                  <b>
                    {toPhone} | {toUsername}
                  </b>
                </p>
              ) : (
                ""
              )}

              <TextField
                label="Group"
                type="text"
                value={toGroup}
                onChange={(e) => setToGroup(e.target.value)}
                variant="standard"
              />
              <TextField
                style={{ marginLeft: "20px" }}
                label="Subscription No"
                type="text"
                value={toSubscription}
                onBlur={() => {
                  checkToInvestment();
                }}
                onChange={(e) => setToSubscription(e.target.value)}
                variant="standard"
              />

              {toPhone ? (
                <Button
                  variant="contained"
                  color="success"
                  style={{ marginLeft: "20px" }}
                  sx={{ mt: 2 }}
                  onClick={() => transferTrxn()}
                >
                  Transfer
                </Button>
              ) : (
                ""
              )}

              <Button
                variant="outlined"
                color="secondary"
                style={{ position: "absolute", top: "0", right: "15px" }}
                sx={{ mt: 2 }}
                onClick={() => setOpen(false)}
              >
                Close
              </Button>
              <div className="row">
                <div className="col-md-12">
                  <hr />
                  <Button
                    variant="contained"
                    className="btn btn-danger"
                    sx={{ mt: 2 }}
                    onClick={() => deleteTrxn()}
                    style={{ backgroundColor: "red" }}
                  >
                    Delete Transaction
                  </Button>

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "orange",
                      color: "black",
                      marginLeft: "20px",
                    }}
                    sx={{ mt: 2 }}
                    onClick={() => hideTrxn()}
                  >
                    Hide transaction for customer
                  </Button>
                </div>
              </div>
            </Box>
          </Modal>
          {data?.transactions.slice().map((transaction, index) => (
            <div
              key={index}
              className="transaction-item"
              onClick={() => {
                openModel(transaction?.investment, transaction?.id);
              }}
              style={transaction?.is_deleted ? { background: "#ef5350", padding: '5px' } : { padding: '5px' }}
            >
              <div
                className="transaction-info"

              >
                <div className="transaction-text">
                  <p className="transaction-description">
                    {transaction?.description || "Null"} (V.
                    {transaction?.voucher || "Null"})
                  </p>
                  <p className="transaction-transaction-type">
                    {transaction?.transaction_type_display || "Null"}
                  </p>
                </div>
                <div>
                  <div className="transaction-text">
                    <p className="transaction-amount">
                      ₹ {parseFloat(transaction?.sub_amt_in_trxn_amt) > 0
                        ? transaction?.sub_amt_in_trxn_amt
                        : transaction?.transaction_type === "migration"
                          ? transaction?.amount
                          : (parseFloat(transaction?.amount) - (parseFloat(transaction?.amount) % subscriptionAmt)) || "Null"}
                    </p>

                    <p className="transaction-date">
                      <strong>{transaction?.transaction_at || "Null"}</strong>
                    </p>
                  </div>
                </div>
              </div>
              <div className="transaction-text">
                <p style={{ fontSize: "12px" }}>
                  {(() => {
                    const amt = parseFloat(transaction?.amount) || 0;
                    const isMigration = transaction?.transaction_type === "migration";
                    const subAmt = parseFloat(transaction?.sub_amt_in_trxn_amt) > 0
                      ? parseFloat(transaction?.sub_amt_in_trxn_amt)
                      : isMigration
                        ? amt
                        : amt - (amt % subscriptionAmt);
                    const penaltyAmt = parseFloat(transaction?.sub_amt_in_trxn_amt) > 0
                      ? parseFloat(transaction?.penalty_in_trxn_amt) || 0
                      : isMigration
                        ? 0
                        : amt % subscriptionAmt;
                    const charge = parseFloat((amt - subAmt - penaltyAmt).toFixed(2));
                    return (
                      <>
                        ₹ {subAmt}
                        {penaltyAmt > 0 && <> + {penaltyAmt}</>}
                        {charge > 0.01 && <> + {charge} (Charge)</>}
                        {" "}= {transaction?.amount}
                      </>
                    );
                  })()}
                </p>
              </div>
            </div>
          ))}
        </div>
      ),
    },
  ];

  return (
    <div>
      {data && (
        <div className="col-md-12">
          <CustomAccordion sections={accordionSections} height={height} />
        </div>
      )}
    </div>
  );
}

export default Transaction;
